//this gives webpack the ability to dynamically import the bootstrap file. It prevents async issues with the ModuleFederationPlugin
import('./bootstrap').catch(err => console.error('Error loading bootstrap:', err));
